import { NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticEventLookup from '../../../DataInterception/EventMapping/Models/StaticEventSearchModal/StaticEventLookup';

@NeoModel
export default class ManageStaticEventComponentVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public eventName: string = "";
    public managedStaticEvent = new StaticEventLookup();

    public async initialise() {
    }
}